export const CLEAR_YOUTUBE_STATE = 'plugins/youtube/CELAR_STATE';
export const SET_YOUTUBE_SEARCH_QUERY = 'plugins/youtube/SET_SEARCH_QUERY';
export const OPEN_YOUTUBE_SORT_LAYER = 'plugins/youtube/OPEN_SORT_LAYER';
export const CLOSE_YOUTUBE_SORT_LAYER = 'plugins/youtube/CLOSE_SORT_LAYER';
export const SET_YOUTUBE_SORT_OPTION = 'plugins/youtube/SET_SORT_OPTION';
export const SEARCH_YOUTUBE_VIDEOS = 'plugins/youtube/SEARCH_VIDEOS';
export const INIT_YOUTUBE_VIDEOS = 'plugins/youtube/INIT_VIDEOS';
export const SEARCH_MORE_YOUTUBE_VIDEOS = 'plugins/youtube/SEARCH_MORE_VIDEOS';
export const APPEND_YOUTUBE_VIDEOS = 'plugins/youtube/APPEND_VIDEOS';
